<template>
    <div :key="linkKey">
        <b-link @click="openModal">
            <i :class="icon" />
        </b-link>

        <b-modal :id="modalKey" :key="modalKey" :title="modalTitle" hide-footer>
            <b-alert variant="warning" show>
                {{ modalMessage }}
            </b-alert>
            <b-button size="sm" variant="primary" @click="updateFlag">
                Valider
            </b-button>
            <b-button size="sm" variant="secondary" @click="closeModal">
                Annuler
            </b-button>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'TableSupervisionFlagHandler',

    props: {
        client: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: {},
            linkKey: '',
            modalKey: `supModalKey${this.client.id}`,
            show: false,
            checkedIcon: 'fas fa-fw fa-check-square text-success',
            unCheckedIcon: 'far fa-fw fa-square text-secondary',
            errorIcon: 'fas fa-fw fa-exclamation-circle text-danger',
            icon: null,
        }
    },

    computed: {
        modalTitle() {
            return this.client.needs_supervision
                ? 'Désactivation de la supervision du bilan'
                : 'Activation de la supervision du bilan'
        },

        modalMessage() {
            return this.client.needs_supervision
                ? `Etes-vous sûr·e de vouloir désactiver les futures échéances de supervision du bilan pour ${this.client.name} ?`
                : `Etes-vous sûr·e de vouloir réactiver les futures échéances de supervision du bilan pour ${this.client.name} ?`
        },
    },

    created() {
        this.resetIcon()
    },

    methods: {
        openModal() {
            this.$bvModal.show(this.modalKey)
        },

        closeModal() {
            this.$bvModal.hide(this.modalKey)
        },

        updateLinkKey() {
            this.linkKey = `supLinkKey${this.client.id}${Date.now()}`
        },

        resetIcon() {
            this.setIcon(this.client.needs_supervision)
        },

        setIcon(checked) {
            this.icon =
                checked === 1 || checked === true
                    ? this.checkedIcon
                    : this.unCheckedIcon
            this.updateLinkKey()
        },

        async updateFlag() {
            try {
                const response = await axios.put(
                    `/clients/${this.client.id}/needs-supervision`,
                    this.form
                )
                this.setIcon(response.data.data.needs_supervision)
                this.$emit('supervision-flag-has-changed')
            } catch (error) {
                this.handleError()
                console.log(error)
            }
            this.closeModal()
        },

        handleError() {
            this.icon = this.errorIcon
            this.updateLinkKey()
            setTimeout(this.resetIcon, 700)
        },
    },
}
</script>

<style scoped></style>
